import React from "react";

const DashboardGraph = () => {
  return (
    <div className="border mt-5 h-[20vh]">
      <p>Graph</p>
    </div>
  );
};

export default DashboardGraph;
